import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'ExperienceComment',
    column_type: 'id',
  },
  created_at: {
    model_name: 'ExperienceComment',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'ExperienceComment',
    column_type: 'datetime',
  },
  commentable_type: {
    model_name: 'ExperienceComment',
    column_type: 'string',
  },
  content: {
    model_name: 'ExperienceComment',
    column_type: 'string',
  },
  approved_comments_count: {
    model_name: 'ExperienceComment',
    column_type: 'integer',
  },
  commentable: {
    model_name: 'ExperienceComment',
    column_type: 'belongs_to',
    extra: {
      polymorphic: true,
      association_name: 'commentable',
      model_name: '',
      foreign_key: 'commentable_id',
    },
  },
  commentable_id: {
    model_name: 'ExperienceComment',
    column_type: 'belongs_to',
    extra: {
      polymorphic: true,
      association_name: 'commentable',
      model_name: '',
      foreign_key: 'commentable_id',
    },
  },
  comments_count: {
    model_name: 'ExperienceComment',
    column_type: 'integer',
  },
  likes_count: {
    model_name: 'ExperienceComment',
    column_type: 'integer',
  },
  state: {
    model_name: 'ExperienceComment',
    column_type: 'enum',
  },
  creator: {
    model_name: 'ExperienceComment',
    column_type: 'belongs_to',
    extra: {
      polymorphic: true,
      association_name: 'creator',
      model_name: '',
      foreign_key: 'creator_id',
    },
  },
  creator_id: {
    model_name: 'ExperienceComment',
    column_type: 'belongs_to',
    extra: {
      polymorphic: true,
      association_name: 'creator',
      model_name: '',
      foreign_key: 'creator_id',
    },
  },
  creator_type: {
    model_name: 'ExperienceComment',
    column_type: 'string',
  },
  deleted_at: {
    model_name: 'ExperienceComment',
    column_type: 'datetime',
  },
  position: {
    model_name: 'ExperienceComment',
    column_type: 'integer',
  },
  is_deleted: {
    model_name: 'ExperienceComment',
    column_type: 'boolean',
  },
  is_top: {
    model_name: 'ExperienceComment',
    column_type: 'boolean',
  },
  parent: {
    model_name: 'ExperienceComment',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'parent',
      model_name: 'Comment',
      foreign_key: 'parent_id',
    },
  },
  parent_id: {
    model_name: 'ExperienceComment',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'parent',
      model_name: 'Comment',
      foreign_key: 'parent_id',
    },
  },
  root: {
    model_name: 'ExperienceComment',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'root',
      model_name: 'Comment',
      foreign_key: 'root_id',
    },
  },
  root_id: {
    model_name: 'ExperienceComment',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'root',
      model_name: 'Comment',
      foreign_key: 'root_id',
    },
  },
  admin_read: {
    model_name: 'ExperienceComment',
    column_type: 'boolean',
  },
  commentable_comment_datum: {
    model_name: 'ExperienceComment',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'commentable_comment_datum',
      model_name: 'CommentableCommentDatum',
      foreign_key: 'target_id',
    },
  },
  target_id: {
    model_name: 'ExperienceComment',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'commentable_comment_datum',
      model_name: 'CommentableCommentDatum',
      foreign_key: 'target_id',
    },
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
